export default [
  // Bridge - 3:09

  {m:97, t: 1, pos: 1}, {m:97, t: 1, pos: 3},
  // {m:97, t: 2, pos: 4},
  // {m:97, t: 3, pos: 3},
  {m:97, t: 4, pos: 1, hold: 3}, {m:97, t: 4, pos: 3, hold: 3},
  // {m:97, t: 5, pos: 5},
  // {m:97, t: 6, pos: 2},
  {m:97, t: 7, pos: 1}, {m:97, t: 7, pos: 3},
  {m:97, t: 8, pos: 1}, {m:97, t: 8, pos: 3},
  {m:97, t: 8.5, pos: 1}, {m:97, t: 8.5, pos: 3},

  {m:98, t: 1, pos: 2}, {m:98, t: 1, pos: 3},
  // {m:98, t: 2, pos: 4},
  // {m:98, t: 3, pos: 3},
  {m:98, t: 4, pos: 2, hold: 3}, {m:98, t: 4, pos: 3, hold: 3},
  // {m:98, t: 5, pos: 5},
  // {m:98, t: 6, pos: 2},
  {m:98, t: 7, pos: 2}, {m:98, t: 7, pos: 3},
  // {m:98, t: 8, pos: 1},

  {m:99, t: 1, pos: 3, hold: 7}, {m:99, t: 1, pos: 4, hold: 7},  {m:99, t: 1, pos: 5, hold: 7},
  // {m:99, t: 2, pos: 4},
  // {m:99, t: 3, pos: 3},
  // {m:99, t: 4, pos: 2},
  // {m:99, t: 5, pos: 5},
  // {m:99, t: 6, pos: 2},
  // {m:99, t: 7, pos: 2},
  {m:99, t: 8.5, pos: 4},
  {m:99, t: 8.75, pos: 5, hold: 1.25},

  // {m:100, t: 1, pos: 2},
  {m:100, t: 2, pos: 4},
  {m:100, t: 3, pos: 3},
  {m:100, t: 4, pos: 2},
  {m:100, t: 5, pos: 1},
  {m:100, t: 6, pos: 4},
  {m:100, t: 7, pos: 3},
  {m:100, t: 8, pos: 2},

  {m:101, t: 1, pos: 1}, {m:101, t: 1, pos: 3},
  // {m:101, t: 2, pos: 4},
  // {m:101, t: 3, pos: 3},
  {m:101, t: 4, pos: 1, hold: 3}, {m:101, t: 4, pos: 3, hold: 3},
  // {m:101, t: 5, pos: 5},
  // {m:101, t: 6, pos: 2},
  // {m:101, t: 7, pos: 1},
  {m:101, t: 8, pos: 1}, {m:101, t: 8, pos: 3},
  {m:101, t: 8.5, pos: 1}, {m:101, t: 8.5, pos: 3},

  {m:102, t: 1, pos: 2}, {m:102, t: 1, pos: 3},
  // {m:102, t: 2, pos: 4},
  // {m:102, t: 3, pos: 3},
  {m:102, t: 4, pos: 2, hold: 3}, {m:102, t: 4, pos: 3, hold: 3},
  // {m:102, t: 5, pos: 5},
  // {m:102, t: 6, pos: 2},
  // {m:102, t: 7, pos: 2},
  {m:102, t: 8, pos: 2}, {m:102, t: 8, pos: 3},
  {m:102, t: 8.5, pos: 2}, {m:102, t: 8.5, pos: 3},

  {m:103, t: 1, pos: 3, hold: 7}, {m:103, t: 1, pos: 4, hold: 7},
  // {m:103, t: 2, pos: 4},
  // {m:103, t: 3, pos: 3},
  // {m:103, t: 4, pos: 2},
  // {m:103, t: 5, pos: 1},
  // {m:103, t: 6, pos: 4},
  // {m:103, t: 7, pos: 3},
  {m:103, t: 8.5, pos: 3},
  {m:103, t: 8.75, pos: 3},

  {m:104, t: 1, pos: 3}, {m:104, t: 1, pos: 4},
  {m:104, t: 2.33, pos: 3}, {m:104, t: 2.33, pos: 4},
  {m:104, t: 3.66, pos: 3}, {m:104, t: 3.66, pos: 4},
  // {m:104, t: 4, pos: 2},
  {m:104, t: 5, pos: 3}, {m:104, t: 5, pos: 4},
  {m:104, t: 6.33, pos: 3}, {m:104, t: 6.33, pos: 4},
  // {m:104, t: 7, pos: 3},
  {m:104, t: 8, pos: 3}, {m:104, t: 8, pos: 4},

  {m:105, t: 1, pos: 1}, {m:105, t: 1, pos: 3},
  // {m:105, t: 2, pos: 4},
  // {m:105, t: 3, pos: 3},
  {m:105, t: 4, pos: 1, hold: 3}, {m:105, t: 4, pos: 3, hold: 3},
  // {m:105, t: 5, pos: 5},
  // {m:105, t: 6, pos: 2},
  // {m:105, t: 7, pos: 1},
  {m:105, t: 8, pos: 1}, {m:105, t: 8, pos: 3},
  {m:105, t: 8.5, pos: 1}, {m:105, t: 8.5, pos: 3},

  {m:106, t: 1, pos: 2}, {m:106, t: 1, pos: 3},
  // {m:106, t: 2, pos: 4},
  // {m:106, t: 3, pos: 3},
  {m:106, t: 4, pos: 2, hold: 3}, {m:106, t: 4, pos: 3, hold: 3},
  // {m:106, t: 5, pos: 5},
  // {m:106, t: 6, pos: 2},
  // {m:106, t: 7, pos: 2},
  {m:106, t: 8, pos: 2}, {m:106, t: 8, pos: 3},
  {m:106, t: 8.5, pos: 2}, {m:106, t: 8.5, pos: 3},

  {m:107, t: 1, pos: 3, hold: 7}, {m:107, t: 1, pos: 4, hold: 7},
  // {m:107, t: 2, pos: 4},
  // {m:107, t: 3, pos: 3},
  // {m:107, t: 4, pos: 2},
  // {m:107, t: 5, pos: 1},
  // {m:107, t: 6, pos: 4},
  // {m:107, t: 7, pos: 3},
  {m:107, t: 8.5, pos: 4},
  {m:107, t: 8.75, pos: 5, hold: 1.25},

  // {m:108, t: 1, pos: 2},
  {m:108, t: 2, pos: 4},
  {m:108, t: 3, pos: 3},
  {m:108, t: 4, pos: 2},
  {m:108, t: 5, pos: 1},
  {m:108, t: 6, pos: 4},
  {m:108, t: 7, pos: 3},
  {m:108, t: 8, pos: 2},

  {m:109, t: 1, pos: 1}, {m:109, t: 1, pos: 3},
  // {m:109, t: 2, pos: 4},
  // {m:109, t: 3, pos: 3},
  {m:109, t: 4, pos: 1, hold: 3}, {m:109, t: 4, pos: 3, hold: 3},
  // {m:109, t: 5, pos: 5},
  // {m:109, t: 6, pos: 2},
  // {m:109, t: 7, pos: 1},
  {m:109, t: 8, pos: 1}, {m:109, t: 8, pos: 3},
  {m:109, t: 8.5, pos: 1}, {m:109, t: 8.5, pos: 3},

  {m:110, t: 1, pos: 2}, {m:110, t: 1, pos: 3},
  // {m:110, t: 2, pos: 4},
  // {m:110, t: 3, pos: 3},
  {m:110, t: 4, pos: 2, hold: 3}, {m:110, t: 4, pos: 3, hold: 3},
  // {m:110, t: 5, pos: 5},
  // {m:110, t: 6, pos: 2},
  {m:110, t: 7, pos: 2}, {m:110, t: 7, pos: 3},
  {m:110, t: 8, pos: 2}, {m:110, t: 8, pos: 3},

  {m:111, t: 1, pos: 3}, {m:111, t: 1, pos: 4},
  {m:111, t: 2, pos: 3}, {m:111, t: 2, pos: 4},
  {m:111, t: 3, pos: 3}, {m:111, t: 3, pos: 4},
  {m:111, t: 4, pos: 3}, {m:111, t: 4, pos: 4},
  {m:111, t: 5, pos: 3}, {m:111, t: 5, pos: 4},
  {m:111, t: 6, pos: 3}, {m:111, t: 6, pos: 4},
  {m:111, t: 7, pos: 3}, {m:111, t: 7, pos: 4},
  {m:111, t: 8, pos: 3}, {m:111, t: 8, pos: 4},

  {m:112, t: 1, pos: 3}, {m:112, t: 1, pos: 4},
  {m:112, t: 2, pos: 3}, {m:112, t: 2, pos: 4},
  {m:112, t: 3, pos: 3}, {m:112, t: 3, pos: 4},
  {m:112, t: 4, pos: 3}, {m:112, t: 4, pos: 4},
  {m:112, t: 5, pos: 3}, {m:112, t: 5, pos: 4},
  // {m:112, t: 6, pos: 3}, {m:112, t: 6, pos: 4},
  {m:112, t: 7, pos: 4}, {m:112, t: 7, pos: 5},
  // {m:112, t: 8, pos: 3}, {m:112, t: 8, pos: 4},

];



//////////////////
// WEBPACK FOOTER
// ./lib/songs/song_bridge.js
// module id = 16
// module chunks = 0